import React from "react";

//CSS
import "./mandatoryExplanation.css";

//Functions and hooks
import { useTranslation } from "react-i18next";

export default function MandatoryExplanation() {
  const { t } = useTranslation();
  return (
    <span className="mandatory-explanation mt-2">
      <span className="mandatory-explanation-star">*</span>
      {" - " + t("Marks an input field that is mandatory.")}
    </span>
  );
}
